var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDespachosSemana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#17656A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H33M14.3333 9V11.6667M27.6667 9V11.6667M13 22.3333H15.6667M13 27.6667H15.6667M19.6667 22.3333H22.3333M19.6667 27.6667H22.3333M26.3333 22.3333H29M26.3333 27.6667H29M13.2667 33H28.7333C30.2268 33 30.9736 33 31.544 32.7093C32.0457 32.4537 32.4537 32.0457 32.7093 31.544C33 30.9736 33 30.2268 33 28.7333V15.9333C33 14.4399 33 13.6931 32.7093 13.1227C32.4537 12.6209 32.0457 12.213 31.544 11.9573C30.9736 11.6667 30.2268 11.6667 28.7333 11.6667H13.2667C11.7732 11.6667 11.0265 11.6667 10.456 11.9573C9.95425 12.213 9.54631 12.6209 9.29065 13.1227C9 13.6931 9 14.4399 9 15.9333V28.7333C9 30.2268 9 30.9736 9.29065 31.544C9.54631 32.0457 9.95425 32.4537 10.456 32.7093C11.0265 33 11.7732 33 13.2667 33Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDespachosSemana);
export default __webpack_public_path__ + "static/media/iconDespachosSemana.53647143dacf80655eaa1d6c2ea728df.svg";
export { ForwardRef as ReactComponent };